export function getRole() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return user.role || 'VIEWER';
}

export const isAdmin = () => getRole() === 'ADMIN';
export const isDeveloper = () => ['ADMIN', 'DEVELOPER'].includes(getRole());
export const isViewer = () => true; // all roles can view
